import { Link, useLocation } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { useHelpPages } from "@/hooks/useHelp";
import { helpSectionFor } from "@/lib/helpMap";

/** The "?" in the top bar: opens the guide section for the current page
 *  (lib/helpMap.ts), or the guide's front page when nothing matches or
 *  the mirror hasn't loaded yet. */
export function HelpButton() {
  const { pathname } = useLocation();
  const pages = useHelpPages();
  const section = helpSectionFor(pathname);
  const target = pages.data?.find((p) => p.section === section && section > 0);
  const to = target ? `/help/${target.slug}` : "/help";
  return (
    <Link
      to={to}
      data-testid="help-button"
      title={target ? `Help: ${target.title.replace(/^\d+\.\s*/, "")}` : "Help & Training"}
      className="flex h-8 w-8 items-center justify-center rounded-lg border border-line bg-surface text-ink-3 transition-colors hover:bg-raised hover:text-ink"
      aria-label="Help for this page"
    >
      <CircleHelp className="h-4 w-4" />
    </Link>
  );
}
